import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './styles.css';
import { initPwa } from './lib/pwa';

// Capture the install prompt early + register the service worker, before
// React renders, so we don't miss a beforeinstallprompt that fires during
// the Register screen.
initPwa();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
